import { __assign } from "tslib";
import { tripDetailsTokens } from "../trips/trip-details/trip-details.tokens";
export var profileTokens = __assign(__assign({}, tripDetailsTokens), { purple: "#7c3aed", purpleBg: "#f3f0ff", blue: "#1d6fb8", blueBg: "#eff6ff" });
